import { Component, forwardRef, inject, Injector, OnInit, signal, viewChild } from '@angular/core';
import { UserPhoneService } from '../../../services/user/user-phone.service';
import {
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  NgControl,
  NgModel,
  ReactiveFormsModule,
} from '@angular/forms';
import { EnvironmentService } from '../../../services/environment.service';
import { tap } from 'rxjs/operators';
import { NgxMaskDirective } from 'ngx-mask';
import { NgClass } from '@angular/common';
import { SetImgAltDirective } from '../../directives/set-img-alt.directive';
import { CountryService } from '../../../services/country.service';
import { ClickOutsideDirective } from 'ngx-unificator/directives';
import { TranslatePipe } from '../../translation/translate.pipe';

@Component({
  selector: 'app-phone-form',
  templateUrl: './phone-form.component.html',
  styleUrls: ['./phone-form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhoneFormComponent),
      multi: true
    }
  ],
  imports: [SetImgAltDirective, ClickOutsideDirective, NgClass, FormsModule, ReactiveFormsModule, TranslatePipe, NgxMaskDirective, ClickOutsideDirective],
  standalone: true
})
export class PhoneFormComponent implements OnInit, ControlValueAccessor {
  userPhone = inject(UserPhoneService);
  env = inject(EnvironmentService);
  private _country = inject(CountryService);
  private injector = inject(Injector);

  readonly inputModel = viewChild<NgModel>('inputModel');

  public currentCountry = signal<any>(null);
  public ngControl: NgControl | null = null;
  public search: FormControl = new FormControl('');
  private _open = false;
  public filteredCountryList = signal<any[]>([]);

  private _value: string | null = '';
  get value() { return this._value; }
  set value(v: any) { this._value = v; }

  onChange: (val: any) => void = () => {};
  onTouch: () => void = () => {};

  get isOpen(): boolean { return this._open; }

  constructor() {}

  ngOnInit() {
    this.onSelect(this.env.dataEnv()?.country);
    this._onHandleSearch();
    this.ngControl = this.injector.get(NgControl, null);
  }

  writeValue(value: any) {
    this._value = value ?? '';
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}

  onInput(val: string) {
    this._value = val;
    this.onChange(val);
  }

  onBlur() {
    this.onTouch();
  }

  onOpen() {
    this._open = true;
  }

  onClose() {
    this._open = false;
  }

  onSelect(country: any) {
    this.onClose();
    this.currentCountry.set(country.short);
    this.userPhone.updateMainEntities(country?.callingCode, country?.short);
    this.inputModel()?.reset();
  }

  private _onHandleSearch() {
    this.search.valueChanges.pipe(
      tap(value => this.filteredCountryList.set(
        this._country.countryList()?.filter(country => country.name.toLowerCase().includes((value || '').toLowerCase()))
      ))
    ).subscribe();
  }
}
